import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledButton, Icon } from "./Button.style";
import { Link } from "../Link/Link";
export const Button = ({ label, variant = "primary", action = "NONE", inverse = false, leftSvgIcon, rightSvgIcon, size = "medium", disabled, iconOnly = false, fullWidth = false, link, target = "_self", onClick, hasSuccess, "aria-label": ariaLabel, className, showHomeIcon = true, allowTextWrap = false, colorVariant = "default", type }) => {
    const isIconOnly = iconOnly || (!label && !leftSvgIcon && !rightSvgIcon);
    const buttonLabel = label;
    if (variant === "link") {
        return (_jsx(Link, { href: link, target: target, onClick: onClick, children: label }));
    }
    const commonProps = {
        variant,
        inverse,
        size,
        action,
        disabled,
        iconOnly: isIconOnly,
        fullWidth,
        onClick: onClick,
        hasSuccess,
        "aria-label": ariaLabel || (isIconOnly && label ? label : undefined),
        className,
        showHomeIcon,
        allowTextWrap,
        colorVariant,
        type
    };
    const content = (_jsxs(_Fragment, { children: [leftSvgIcon && (_jsx(Icon, { position: "left", size: size, children: leftSvgIcon })), label && !isIconOnly && _jsx("span", { children: buttonLabel }), rightSvgIcon && (_jsx(Icon, { position: "right", size: size, children: rightSvgIcon }))] }));
    return link ? (_jsx(StyledButton, Object.assign({ as: "a", href: link, target: target }, commonProps, { children: content }))) : (_jsx(StyledButton, Object.assign({}, commonProps, { children: content })));
};
//# sourceMappingURL=Button.js.map